module.exports = __webpack_public_path__ + "static/media/almalinux.c5950076.svg";